<ul class="nav nav-pills flex-row gap-2">
  <li *ngFor="let item of menu; trackBy: trackByIndex" class="nav-item" role="presentation">
    <a class="btn btn-outline-light" [class.active]="isCurrentPage(item)"
       [href]="item.LinkUrl"
       [title]="item.Label" [innerHTML]="item.Text"></a>
  </li>
</ul>
